import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "84",
    height: "79",
    viewBox: "0 0 84 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const Stopwatch = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M80.9842 45.6824C80.9842 28.951 67.5549 15.4148 51.0145 15.4148C43.761 15.4148 37.1246 18.016 31.9452 22.3308C31.3087 22.8611 30.3621 22.7749 29.8319 22.1384C29.3018 21.502 29.3881 20.5564 30.0243 20.0261C35.7187 15.2822 43.0285 12.4148 51.0145 12.4148C69.2383 12.4148 83.9842 27.3208 83.9842 45.6824C83.9841 64.0438 69.2382 78.9489 51.0145 78.949C42.3493 78.949 34.4684 75.5684 28.5848 70.0564C27.9803 69.49 27.9491 68.5408 28.5155 67.9363C29.0818 67.3318 30.031 67.3007 30.6356 67.8669C35.9897 72.8829 43.1465 75.949 51.0145 75.949C67.5548 75.9489 80.9841 62.4136 80.9842 45.6824Z"
        {...mergedPathProps}
      />
      <path
        d="M73.0199 11.4269C73.5036 10.7544 74.4411 10.6014 75.1136 11.0851C75.7861 11.5688 75.9391 12.5063 75.4554 13.1789L70.2611 20.4015C69.7774 21.074 68.8398 21.227 68.1673 20.7433C67.4949 20.2596 67.3419 19.3221 67.8255 18.6496L73.0199 11.4269Z"
        {...mergedPathProps}
      />
      <path
        d="M21.6868 38.4285C22.5152 38.4285 23.1868 39.1 23.1868 39.9285C23.1868 40.7569 22.5152 41.4285 21.6868 41.4285H1.51588C0.687453 41.4285 0.0158806 40.7569 0.0158806 39.9285C0.0158806 39.1 0.687453 38.4285 1.51588 38.4285H21.6868Z"
        {...mergedPathProps}
      />
      <path
        d="M33.9559 48.936C34.7842 48.9361 35.4559 49.6077 35.4559 50.436C35.4559 51.2644 34.7842 51.936 33.9559 51.936H9.47931C8.65088 51.936 7.97931 51.2645 7.97931 50.436C7.97931 49.6076 8.65088 48.936 9.47931 48.936H33.9559Z"
        {...mergedPathProps}
      />
      <path
        d="M33.9559 27.9006C34.7842 27.9007 35.4559 28.5723 35.4559 29.4006C35.4559 30.229 34.7842 30.9006 33.9559 30.9006H9.47931C8.65088 30.9006 7.97931 30.2291 7.97931 29.4006C7.97931 28.5722 8.65088 27.9006 9.47931 27.9006H33.9559Z"
        {...mergedPathProps}
      />
      <path
        d="M21.6873 60.4841C22.5157 60.4842 23.1873 61.1557 23.1873 61.9841C23.1873 62.8125 22.5157 63.4841 21.6873 63.4841H2.7488C1.92037 63.4841 1.2488 62.8126 1.2488 61.9841C1.2488 61.1557 1.92037 60.4841 2.7488 60.4841H21.6873Z"
        {...mergedPathProps}
      />
      <path
        d="M49.4942 13.915V1.53027C49.4942 0.701846 50.1658 0.0302734 50.9942 0.0302734C51.8227 0.0302734 52.4942 0.701846 52.4942 1.53027V13.915C52.4941 14.7434 51.8226 15.415 50.9942 15.415C50.1659 15.415 49.4943 14.7434 49.4942 13.915Z"
        {...mergedPathProps}
      />
      <path
        d="M59.5033 0.0302734C60.3318 0.0302734 61.0033 0.701846 61.0033 1.53027C61.0033 2.3587 60.3318 3.03027 59.5033 3.03027H42.5053C41.6769 3.03027 41.0053 2.3587 41.0053 1.53027C41.0053 0.701846 41.6769 0.0302734 42.5053 0.0302734H59.5033Z"
        {...mergedPathProps}
      />
      <path
        d="M68.9851 8.65028C69.4587 7.97064 70.3933 7.80369 71.073 8.27724L79.0974 13.8671C79.7771 14.3407 79.944 15.2763 79.4705 15.9559C78.9969 16.6354 78.0622 16.8022 77.3826 16.329L69.3582 10.7382C68.6785 10.2646 68.5116 9.32998 68.9851 8.65028Z"
        {...mergedPathProps}
      />
      <path
        d="M54.6478 45.7029C54.6478 43.6413 53.0025 41.9999 50.9945 41.9998C48.9864 41.9998 47.3402 43.6412 47.3402 45.7029C47.3404 47.7644 48.9865 49.405 50.9945 49.405C53.0024 49.4049 54.6476 47.7643 54.6478 45.7029ZM57.6478 45.7029C57.6476 49.3945 54.6858 52.4049 50.9945 52.405C47.3031 52.405 44.3404 49.3946 44.3402 45.7029C44.3402 42.011 47.303 38.9998 50.9945 38.9998C54.6859 38.9999 57.6478 42.0111 57.6478 45.7029Z"
        {...mergedPathProps}
      />
      <path
        d="M64.1975 30.2229C64.78 29.6341 65.7296 29.6288 66.3186 30.2112C66.9074 30.7937 66.9127 31.7433 66.3303 32.3323L55.719 43.0638C55.1365 43.6528 54.187 43.6588 53.5979 43.0765C53.0088 42.494 53.0038 41.5445 53.5862 40.9554L64.1975 30.2229Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default Stopwatch;
